import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from "@material-ui/core";
import PaperContainer from '../../Common/PaperContainer';
import AboveTableBtnArea from "../../Common/AboveTableBtnArea";
import t from "../../../languages/pl";
import PricingTable from './PricingTable';
import PricingDialog from './PricingDialog';
import { connect } from 'react-redux';
import { bindActionCreators } from "redux";
import ActionCreator from './../../../store/actions/index';


const Pricing = props => {
    const { pricing, addPricing, putPricing, deleteRentPricing } = props;
    const [singlePricing, setSinglePricing] = useState(null);
    const [pricingId, setpricingId] = useState(null);
    const [open, setOpen] = useState(false);

    const onDetailsClickHandler = id => {
        setSinglePricing(pricing.find(element => element.cennik_id === id));
        setpricingId(id);
        setOpen(true);
    };

    const onCloseHandler = (initialPricing) => {
        setOpen(false);
        setSinglePricing(initialPricing);
        setpricingId(null);
    };

    const onSubmitHandler = (newPricing, initialPricing) => {
        setOpen(false);
        setSinglePricing(initialPricing);
        setpricingId(null);
        addPricing(newPricing);
    };

    const onEditHandler = (updatedPricing, initialPricing) => {
        setOpen(false);
        setSinglePricing(initialPricing);
        setpricingId(null);
        putPricing(updatedPricing.cennik_id, updatedPricing);
    };

    const onPricingDeleteHandler = (id, initialPricing) => {
        setOpen(false);
        setSinglePricing(initialPricing);
        setpricingId(null);
        deleteRentPricing(id);
    };

    return (
        <PaperContainer>
            <AboveTableBtnArea>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => setOpen(true)}
                >
                    {t.addPricing}
                </Button>
            </AboveTableBtnArea>
            <PricingTable
                priceList={pricing}
                onDetailsClick={onDetailsClickHandler}
            />
            <PricingDialog
                open={open}
                singlePricing={singlePricing}
                onClose={onCloseHandler}
                onSubmit={onSubmitHandler}
                onEdit={onEditHandler}
                onPricingDelete={onPricingDeleteHandler}
                isEdit={pricingId !== null}
            />
        </PaperContainer>
    );
};

Pricing.propTypes = {
    pricing: PropTypes.array,
    addPricing: PropTypes.func,
    putPricing: PropTypes.func,
    deleteRentPricing: PropTypes.func
};

const mapStateToProps = state => ({
    pricing: state.rentReducer.pricing,
});

const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActionCreator, dispatch);
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Pricing);
